import { Pipe, PipeTransform } from '@angular/core';
import { ProductModel } from '../models/product.model';

@Pipe({ name: 'productsInBasket', pure:false })
export class ProductsInBasketPipe implements PipeTransform {
  transform(products: ProductModel[]) {
    return products.filter(product => (!!product.basket && product.basket.quantity>0));
  }
}